<!-- #63 -->
<template>
  <v-col class="mx-4">
    <div class="d-flex">
      <div
        class="text-h6 py-0 my-0 pl-0"
        style="color: #23468c; font-weight: 500"
      >
        {{ +$route.params.id === 0 ? "Add" : "Edit" }} a Dashboard & Report
      </div>
    </div>
    <v-divider class="mt-1 mb-4"></v-divider>
    <v-form ref="form" lazy-validation>
      <v-card :loading="pageLoader">
        <v-card-title>
          <span class="body-1 font-weight-bold"
            >{{ +$route.params.id === 0 ? "Add" : "Edit" }}
            <i class="caption red--text ml-4"> * required field</i>
          </span>
        </v-card-title>
        <v-divider></v-divider>
        <v-card-text>
          <v-row>
            <v-col cols="12" md="4" sm="6">
              <v-select
                v-model="reportDetails.type"
                label="Type"
                :rules="[
                  (v) =>
                    (v !== '' && v !== null && v !== undefined) ||
                    'Type is required.',
                ]"
                class="required"
                :items="reportTypes"
                outlined
              ></v-select>
            </v-col>
            <v-col cols="12" md="4" sm="6">
              <v-select
                v-model="reportDetails.user_category"
                label="User Category"
                :rules="[
                  (v) =>
                    (v !== '' && v !== null && v !== undefined) ||
                    'User category is required.',
                ]"
                class="required"
                item-text="value"
                item-value="id"
                :items="userTypes"
                outlined
                @change="fetchRSAUserGroupList()"
              ></v-select>
            </v-col>
            <v-col
              cols="12"
              md="4"
              sm="6"
              v-if="
                reportDetails.user_category == 3 ||
                reportDetails.user_category == 6
              "
            >
              <v-autocomplete
                v-model="user_gropu_id_value"
                :items="userGroup"
                :loading="userLoader"
                hide-no-data
                item-text="name"
                item-value="id"
                label="Select User Group"
                placeholder="Start typing to Search"
                :rules="[
                  (v) => (v && v.length > 0) || 'Please select a User Group.',
                ]"
                class="required"
                multiple
                outlined
              ></v-autocomplete>
            </v-col>
            <v-col
              cols="12"
              md="4"
              sm="6"
              v-if="
                reportDetails.user_category != 3 &&
                reportDetails.user_category != 6
              "
            >
              <v-select
                v-model="reportDetails.client_type_id"
                label="Type of Client"
                :rules="[(v) => !!v || 'Type of client is required.']"
                class="required"
                item-text="name"
                item-value="id"
                :items="clientTypes"
                outlined
                @change="fetchClientList('true')"
              ></v-select>
            </v-col>
            <v-col
              cols="12"
              md="4"
              sm="6"
              v-if="
                reportDetails.user_category != 3 &&
                reportDetails.user_category != 6
              "
            >
              <v-autocomplete
                v-model="value"
                :items="clients"
                :loading="clientLoader"
                hide-no-data
                item-text="name"
                item-value="id"
                label="Select client"
                multiple
                placeholder="Start typing to Search"
                :rules="[
                  (v) => (v && v.length > 0) || 'Please select a client.',
                ]"
                class="required"
                outlined
              ></v-autocomplete>
            </v-col>
            <v-col cols="12" md="4" sm="6">
              <v-text-field
                v-model="reportDetails.name"
                label="Dashboard / Report Name"
                :rules="[
                  (v) =>
                    (v && !!v.trim()) || 'Dashboard / Report name is required.',
                ]"
                class="required"
                outlined
              ></v-text-field>
            </v-col>
            <v-col cols="12" md="4" sm="6">
              <v-select
                v-model="reportDetails.tool"
                label="Tool"
                :rules="[
                  (v) =>
                    (v !== '' && v !== null && v !== undefined) ||
                    'Tool is required.',
                ]"
                :items="reportTools"
                outlined
                class="required"
              ></v-select>
            </v-col>
            <!-- <v-col cols="12" md="4" sm="6">
              <v-text-field
                v-model="reportDetails.dashboard_id"
                label="Dashboard ID"
                :rules="[
                  (v) => (v && !!v.trim()) || 'Dashboard ID is required.',
                ]"
                class="required"
              ></v-text-field>
            </v-col>
            <v-col cols="12" md="4" sm="6">
              <v-text-field
                v-model="reportDetails.group_id"
                label="Group ID"
                :rules="[(v) => (v && !!v.trim()) || 'Group ID is required.']"
                class="required"
              ></v-text-field>
            </v-col> -->
            <v-col cols="12" md="4" sm="6">
              <v-text-field
                v-model="reportDetails.tile_id"
                label="Tile ID"
                :rules="[(v) => (v && !!v.trim()) || 'Tile ID is required.']"
                class="required"
                outlined
              ></v-text-field>
            </v-col>
            <!-- <v-col cols="12" md="4" sm="6">
              <v-text-field
                v-model="reportDetails.background"
                label="Background"
                :rules="[(v) => (v && !!v.trim()) || 'Background is required.']"
                class="required"
              ></v-text-field>
            </v-col> -->
            <v-col cols="12" md="4" sm="6">
              <v-select
                v-model="reportDetails.visible_to_client"
                label="Visible to Client"
                :rules="[
                  (v) =>
                    (v !== '' && v !== null && v !== undefined) ||
                    'Field is required.',
                ]"
                class="required"
                outlined
                :items="[
                  {
                    text: 'Yes',
                    value: true,
                  },
                  {
                    text: 'No',
                    value: false,
                  },
                ]"
              ></v-select>
            </v-col>
            <v-col cols="12" md="4" sm="6">
              <v-switch
                v-model="reportDetails.active"
                label="Active"
              ></v-switch>
            </v-col>
          </v-row>
          <v-row>
            <v-card-actions>
              <v-btn
                v-if="$route.params.id == 0"
                color="primary"
                @click="save"
                :loading="saveloader"
                class="ma-2"
                >Save</v-btn
              >
              <v-btn
                v-if="$route.params.id > 0"
                color="primary"
                @click="save"
                :loading="saveloader"
                class="ma-2"
                >Update</v-btn
              >
              <v-btn
                v-if="$route.params.id > 0"
                class="ml-3"
                color="error"
                @click="$router.push('/dashboards-reports')"
              >
                Cancel
              </v-btn>
            </v-card-actions>
          </v-row>
        </v-card-text>
      </v-card>
    </v-form>
  </v-col>
</template>
<script>
import { mapActions, mapGetters } from "vuex";
import { reportTypes, reportTools } from "@/config/data";

export default {
  computed: {
    ...mapGetters(["clientTypes", "userTypes"]),
    reportTypes() {
      return reportTypes;
    },
    reportTools() {
      return reportTools;
    },
  },
  data() {
    return {
      pageLoader: false,
      saveLoader: false,
      reportDetails: {},
      clientLoader: false,
      userLoader: false,
      clients: [],
      userGroup: [],
      value: [],
      user_gropu_id_value: [],
    };
  },
  created() {
    if (+this.$route.params.id !== 0) {
      this.fetchDetails();
    }
    this.fetchClientList();
    this.fetchRSAUserGroupList();
    this.getClientTypes();
    this.getUserTypes();
  },
  methods: {
    ...mapActions([
      "snackBar",
      "getDReportDetails",
      "createDReport",
      "updateDReport",
      "getTypeClients",
      "fetchClient",
      "getClientTypes",
      "getRSAUserGroup",
      "getUserTypes",
    ]),

    // fetchClientList() {
    //   if (!this.reportDetails.client_type_id) return;
    //   this.clientLoader = true;
    //   this.getTypeClients(this.reportDetails.client_type_id)
    //     .then((res) => {
    //       this.clientLoader = false;
    //       this.clients = res.data;
    //     })
    //     .catch(() => {
    //       this.clientLoader = false;
    //     });
    // },

    async fetchClientList(clicked) {
      if (!this.reportDetails.client_type_id) return;
      this.clientLoader = true;
      await this.fetchClient({
        fields: "id,name",
        pagination: 0,
        service: this.reportDetails.client_type_id,
      })
        .then((res) => {
          this.clientLoader = false;
          this.clients = res.data;
          if (clicked) this.value = [];
        })
        .catch(() => {
          this.clientLoader = false;
        });
    },

    fetchRSAUserGroupList() {
      if (!this.reportDetails.user_category) return;
      this.userLoader = true;
      this.getRSAUserGroup({
        fields: "id,name",
        pagination: 0,
        service: this.reportDetails.user_category,
      })
        .then((res) => {
          this.userLoader = false;
          this.userGroup = res.data;
        })
        .catch(() => {
          this.userLoader = false;
        });
    },

    fetchDetails() {
      this.pageLoader = true;
      this.getDReportDetails(this.$route.params.id)
        .then(async (res) => {
          this.pageLoader = false;
          this.reportDetails = res.data;
          this.fetchRSAUserGroupList();
          await this.fetchClientList();
          if (this.reportDetails.client_id)
            this.value = this.reportDetails.client_id.split(",").map(Number);
          this.reportDetails.user_category = res.data.user_category;
          this.user_gropu_id_value = this.reportDetails.user_group_id
            .split(",")
            .map(Number);
        })
        .catch(() => {
          this.pageLoader = false;
        });
    },

    save() {
      if (!this.$refs.form.validate()) {
        return;
      }
      this.saveLoader = true;
      this.reportDetails.client_id = this.value.join(",");
      if (this.user_gropu_id_value)
        this.reportDetails.user_group_id = this.user_gropu_id_value.join(",");
      if (+this.$route.params.id !== 0) {
        this.updateDReport({
          id: this.$route.params.id,
          data: this.reportDetails,
        })
          .then((res) => {
            this.saveLoader = false;
            this.snackBar({
              color: "success",
              message: res.data.message,
            });
            this.$router.replace({
              name: "DashBoardsReports",
            });
          })
          .catch(() => {
            this.saveLoader = false;
          });
      } else {
        this.createDReport(this.reportDetails)
          .then((res) => {
            this.saveLoader = false;
            this.snackBar({
              color: "success",
              message: res.data.message,
            });
            this.$router.replace({
              name: "DashBoardsReports",
            });
          })
          .catch(() => {
            this.saveLoader = false;
          });
      }
    },
  },
};
</script>
